/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ------------------------------------------------------------------
  // Size selector: require an explicit choice before "Add to cart".
  //
  // The size dropdown (see snippets/product-variant-picker.liquid /
  // product-variant-options.liquid) no longer pre-selects a value, so the
  // hidden input Shopify/theme.js reads (`[data-popout-input]` marked with
  // `data-size-required`) starts empty. We block the add-to-cart submit
  // here, before product-form's own submit handler runs (this listener is
  // registered on `document` in the capture phase, which always fires
  // before bubble-phase listeners on the form itself), and show a subtle
  // error state instead of letting the request go through.
  // ------------------------------------------------------------------
  function getSizeSelectors(scope) {
    return scope.querySelectorAll('[data-size-selector]');
  }

  function isSizeSelected(sizeWrapper) {
    var checkedRadio = sizeWrapper.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return true;

    var popoutInput = sizeWrapper.querySelector('[data-popout-input]');
    if (popoutInput) return popoutInput.value.trim() !== '';

    var nativeSelect = sizeWrapper.querySelector('select');
    if (nativeSelect) return nativeSelect.value.trim() !== '';

    return true;
  }

  function clearSizeError(sizeWrapper) {
    sizeWrapper.classList.remove('size-selector--missing');
    sizeWrapper.removeAttribute('aria-invalid');
  }

  function showSizeError(sizeWrapper, form) {
    sizeWrapper.classList.add('size-selector--missing');
    sizeWrapper.setAttribute('aria-invalid', 'true');

    var submitButton = form && form.querySelector('[data-add-to-cart]');
    if (!submitButton) return;

    submitButton.classList.remove('size-selector-shake');
    // Force reflow so the animation can replay on repeated attempts.
    void submitButton.offsetWidth;
    submitButton.classList.add('size-selector-shake');
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-product-form')) return;

      var scope = form.closest('product-info') || form;
      var sizeWrappers = getSizeSelectors(scope);
      if (!sizeWrappers.length) return;

      var missing = false;
      sizeWrappers.forEach(function (wrapper) {
        if (isSizeSelected(wrapper)) {
          clearSizeError(wrapper);
        } else {
          missing = true;
          showSizeError(wrapper, form);
        }
      });

      if (missing) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // Clear the error as soon as the customer picks a size.
  document.addEventListener('change', function (event) {
    var wrapper = event.target.closest && event.target.closest('[data-size-selector]');
    if (wrapper && isSizeSelected(wrapper)) clearSizeError(wrapper);
  });

  document.addEventListener('animationend', function (event) {
    if (event.target.classList.contains('size-selector-shake')) {
      event.target.classList.remove('size-selector-shake');
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
